export default "__VITE_ASSET__DWK4gUSh__"